(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7066],{

/***/ 23295:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/site-map",
      function () {
        return __webpack_require__(81901);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 81901:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ site_map; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/components/Layout.tsx + 1 modules
var Layout = __webpack_require__(22932);
// EXTERNAL MODULE: ./src/components/Container.tsx
var Container = __webpack_require__(3210);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/hooks/useQueryParam.tsx
var useQueryParam = __webpack_require__(73401);
;// CONCATENATED MODULE: ./src/components/SitemapPage/SitemapSection.tsx




var SitemapSection = function(param) {
    var title = param.title, items = param.items;
    var query = (0,useQueryParam/* useQueryParam */.W)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mb-8",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                style: {
                    fontWeight: 700
                },
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                style: {
                    listStyleType: "none",
                    paddingLeft: 0
                },
                children: items.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        style: {
                            paddingTop: index === 0 ? 0 : 20
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: item.path,
                            as: {
                                pathname: item.path,
                                query: query
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "text-lg",
                                children: item.title
                            })
                        })
                    }, item.title);
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@builder.io/react/dist/builder-react.es5.js
var builder_react_es5 = __webpack_require__(18202);
;// CONCATENATED MODULE: ./src/pages/site-map.tsx







builder_react_es5/* default.init */.ZP.init("ed7f20b509364fd4a7e520373ff39fd7");
var Sitemap = function(param) {
    var sections = param.sections, preview = param.preview;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        title: "Site Map - NuBrakes Mobile Brake Repair",
        preview: preview,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Nubrakes sitemap."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Site Map - NuBrakes Mobile Brake Repair"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "mb-8",
                            children: "Sitemap"
                        }),
                        sections.map(function(section) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SitemapSection, {
                                title: section.title,
                                items: section.items
                            }, section.title);
                        })
                    ]
                })
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var site_map = (Sitemap);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4976,2978,8202,2932,9774,2888,179], function() { return __webpack_exec__(23295); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);